import React from 'react'
import { Card } from 'components/Core/Card/Card'
import { Dropdown, IDropdownOption, Input } from 'components/Core'

export type IVaultCalculatorInput = {
    period: IDropdownOption;
    initialAmount: number | string | null,
    monthlyAmount: number | string | null
}

export const vaultChartPeriods = [
    { label: '12 months', value: 360 },
    { label: '2 years', value: 720 },
    { label: '3 years', value: 1080 },
    { label: '5 years', value: 1800 },
]

export const VaultCalculator = ({
    value,
    onChange,
}: {
    value: IVaultCalculatorInput
    onChange: (key: string) => (value: any) => void
}) => {
    // #region HOOKS
    // #endregion

    // #region STORE
    // #endregion

    // #region HANDLERS
    const handleChange = (key: string) => (value: any) => {
        onChange?.(key)(value)
    }
    // #endregion

    // #region STYLES
    const cardStyle = {
        width: 'calc(100% - 0.5rem)',
        padding: '0.5rem',
        paddingLeft: '0.25rem',
        paddingRight: '0.25rem',
        border: '1px solid #EFEFEF',
        borderRadius: '1rem'
    }
    // #endregion

    return (
        <div style={{ minWidth: '20rem', maxWidth: '30rem', margin: 'auto' }}>
            <Card style={cardStyle}>
                <Input
                    label="Starting contribution"
                    value={
                        value?.initialAmount
                    }
                    onChange={handleChange('initialAmount')}
                />
            </Card>
            <br />
            <br />
            <Card style={cardStyle}>
                <Input
                    label="Monthly contribution"
                    value={

                        value?.monthlyAmount
                    }
                    onChange={handleChange('monthlyAmount')}
                />
            </Card>
            <br />
            <br />
            <Dropdown
                value={value.period}
                options={vaultChartPeriods}
                onChange={handleChange('period')}
            />
        </div>
    )
}